"use client";

import { useState } from "react";
import Link from "next/link";
import { SearchInput } from "./search";
import { NavDrawer } from "./NavDrawer";
import { HamburgerSmilIcon } from "./HamburgerSmilIcon";
import { MobileSearchToggle } from "./MobileSearchToggle";
import { AuthButton } from "./AuthButton";
import { AgenticButton } from "./AgenticButton";
import { WorkerHealthBadge } from "./WorkerHealthBadge";
import { BrandLogo, Container } from "@/components/ui";
import { useMobileHeaderSearch } from "./useMobileHeaderSearch";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isMobileSearchOpen, isMobileTitleHidden, setMobileSearchOpen } =
    useMobileHeaderSearch();

  return (
    <>
      <header className="sticky top-0 z-50 h-[var(--header-height)] border-b border-[#2a475e]/40 bg-gradient-to-r from-[#16202d]/80 via-[#1a2838]/80 to-[#16202d]/80 backdrop-blur-md shadow-lg relative">
        <div className="absolute inset-0 bg-gradient-to-r from-[#66c0f4]/5 via-transparent to-[#66c0f4]/5 animate-pulse opacity-50 pointer-events-none" />
        <Container>
          <div className="flex items-center gap-2 sm:gap-3 h-[var(--header-height)] relative z-10">
            <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0 min-w-0">
              <button
                onClick={() => setIsMenuOpen((v) => !v)}
                className="p-1.5 rounded-lg border border-[#2a475e]/70 bg-[#1b2838]/60 hover:bg-[#1f2e3f] hover:border-[#3a556e] transition-all flex-shrink-0 relative group focus:outline-none focus:ring-2 focus:ring-[#66c0f4]/30"
                aria-label="Toggle menu"
                aria-expanded={isMenuOpen}
              >
                <HamburgerSmilIcon
                  open={isMenuOpen}
                  className="text-[#c7d5e0] group-hover:text-[#66c0f4] transition-colors"
                />
                <div className="absolute inset-0 rounded-lg bg-[#66c0f4]/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
              </button>

              <Link
                href="/"
                className="flex items-center hover:opacity-80 transition-all group"
              >
                <div className="relative">
                  {/* Mobile: тільки іконка */}
                  <div className="sm:hidden">
                    <BrandLogo variant="icon" height={36} />
                  </div>
                  {/* Desktop: повний логотип з текстом */}
                  <div
                    className={[
                      "hidden sm:block transition-all duration-200",
                      isMobileTitleHidden
                        ? "opacity-0 pointer-events-none"
                        : "opacity-100",
                    ].join(" ")}
                  >
                    <BrandLogo variant="full" height={44} />
                  </div>
                  <div className="absolute inset-0 bg-[#66c0f4]/10 rounded-xl blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                </div>
              </Link>
            </div>

            <div className="ml-auto flex items-center gap-2">
              <WorkerHealthBadge />
              <div className="hidden sm:block min-w-0 w-[280px] md:w-[320px] lg:w-[360px] xl:w-[420px]">
                <SearchInput />
              </div>
            </div>
            <div className="sm:hidden min-w-0 ml-auto flex-1 flex justify-end">
              <MobileSearchToggle
                open={isMobileSearchOpen}
                onOpenChange={setMobileSearchOpen}
              />
            </div>
            <div className="flex flex-shrink-0 items-center gap-2">
              <AgenticButton />
              <AuthButton />
            </div>
          </div>
        </Container>
      </header>
      <NavDrawer isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
}
